export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/EGBANK-logo.82501cb8.svg","height":13,"width":83,"blurWidth":0,"blurHeight":0};